import { Container } from "meta/ui2/layout";
import HeaderUserIcon from "../HeaderIcons/HeaderUserIcon";
import HeaderLogoutIcon from "../HeaderIcons/HeaderLogoutIcon";
import HeaderLockIcon from "../HeaderIcons/HeaderLockIcon";
import HeaderLoginIcon from "../HeaderIcons/HeaderLoginIcon";
import { useAppSelector } from "screens/Root/hooks/useAppSelector";
import HeaderSearchIcon from "../HeaderIcons/HeaderSearchIcon";
import ResponsiveTopMenu from "./ResponsiveTopMenu";
import HeaderNotificationsContainer from "../HeaderIcons/HeaderNotificationsContainer";
import HeaderHelpIcon from "../HeaderIcons/Help/HeaderHelpIcon";
const TopMenu = () => {
    const isLogged = useAppSelector((state) => state.root.isLogged);
    return (<Container data-identification="top-right-menu" className="root-menu">
      {isLogged ? (<>
          <div className="divider"></div>
          <ResponsiveTopMenu />
          <HeaderNotificationsContainer />
          <HeaderSearchIcon />
          <HeaderHelpIcon />
          <HeaderLockIcon />
          <HeaderLogoutIcon />
          <HeaderUserIcon />
        </>) : (<HeaderLoginIcon />)}
    </Container>);
};
export default TopMenu;
